/* eslint-disable react/jsx-no-useless-fragment */
import React from "react";
import CloseIcon from "../../Common/Svgs/CloseIcon";
import AlertIcon from "../../Common/Svgs/AlertIcon";

const ToastMessageModal = ({ visible, onCancel, title, description }) => {
  if (!visible) {
    return <></>;
  }

  return (
    <>
      <div className="hidden lg:block fixed bottom-4 z-200 right-4 p-4 rounded-xl w-[420px] bg-background-white shadow-toastMessage border border-light-grey">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-alert-red">
            <AlertIcon size={24} className="text-white" />
          </div>
          <CloseIcon
            onClick={onCancel}
            className="w-4 h-4 cursor-pointer stroke-dark-gray"
          />
        </div>
        <div className="flex flex-col px-2 mt-2 gap-y-2">
          <p className="text-base font-medium text-black capitalize font-poppins">
            {title}
          </p>
          <p className="text-xs font-normal text-dark-gray font-poppins">
            {description}
          </p>
        </div>
      </div>
      <div className="block lg:hidden fixed bottom-4 z-200 right-4 p-4 rounded-xl w-[320px] bg-background-white shadow-toastMessage border border-light-grey">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-alert-red">
            <AlertIcon size={24} className="text-white" />
          </div>
          <CloseIcon
            onClick={onCancel}
            className="w-4 h-4 cursor-pointer stroke-dark-gray"
          />
        </div>
        <div className="flex flex-col px-2 mt-2 gap-y-2">
          <p className="text-base font-medium text-black capitalize font-poppins">
            {title}
          </p>
          <p className="text-xs font-light text-dark-gray font-poppins">
            {description}
          </p>
        </div>
      </div>
    </>
  );
};

export default ToastMessageModal;
